export const loadAsyncAction = (dispatch, action, args = {}) =>
  new Promise((resolve, reject) =>
    dispatch(action.load({ resolve, reject, ...args }))
  );
